function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.520996,
  width: 55,
  height: 55,
  rx: 7.95,
  fill: "#ECF4FD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.092 29.8704C22.6726 29.8704 23.1438 30.3409 23.1438 30.9222V40.8621H16.8328V30.9222C16.8328 30.3409 17.304 29.8704 17.8846 29.8704H22.092Z",
  fill: "#4B93C8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.5068 23.5593C31.0874 23.5593 31.5586 24.0298 31.5586 24.6112V40.8621H25.2476V24.6112C25.2476 24.0298 25.7188 23.5593 26.2994 23.5593H30.5068Z",
  fill: "#4B93C8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M38.9215 29.8704C39.5022 29.8704 39.9734 30.3409 39.9734 30.9222V40.8621H33.6624V30.9222C33.6624 30.3409 34.1336 29.8704 34.7142 29.8704H38.9215Z",
  fill: "#4B93C8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M46.3544 44.0174C46.3544 44.5981 45.8832 45.0693 45.3026 45.0693H11.5035C10.9229 45.0693 10.4517 44.5981 10.4517 44.0174V10.2183C10.4517 9.63773 10.9229 9.1665 11.5035 9.1665C12.0841 9.1665 12.5553 9.63773 12.5553 10.2183V22.8579H21.2197L27.5532 14.174C27.9459 13.6039 28.8602 13.6039 29.2529 14.174L35.5864 22.8579H42.7635L41.6548 21.7493C41.2446 21.3384 41.2446 20.6729 41.6548 20.262C42.0657 19.8511 42.7319 19.8511 43.1428 20.262L46.0466 23.1658C46.4477 23.5529 46.4547 24.2492 46.0564 24.6419C46.0508 24.6489 46.0438 24.6552 46.0375 24.6622L43.0636 27.566C42.8588 27.7658 42.5938 27.8654 42.3287 27.8654C42.0552 27.8654 41.7824 27.7588 41.5763 27.5477C41.1703 27.1326 41.178 26.4665 41.5938 26.0604L42.72 24.9616H35.0514C34.7155 24.9616 34.3992 24.801 34.2015 24.529L28.403 16.5785L22.6046 24.529C22.4069 24.801 22.0906 24.9616 21.7547 24.9616H12.5553V42.9656H45.3026C45.8832 42.9656 46.3544 43.4368 46.3544 44.0174Z",
  fill: "#4B93C8"
});

function SvgAvgReimbursementBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgReimbursementBlue);
export default __webpack_public_path__ + "static/media/avg_reimbursement_blue.6649cbc6.svg";
export { ForwardRef as ReactComponent };